import { render, staticRenderFns } from "./IconTooltip.vue?vue&type=template&id=cdbf20a2&scoped=true&"
import script from "./IconTooltip.vue?vue&type=script&lang=js&"
export * from "./IconTooltip.vue?vue&type=script&lang=js&"
import style0 from "./IconTooltip.vue?vue&type=style&index=0&id=cdbf20a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdbf20a2",
  null
  
)

export default component.exports